import React, { useLayoutEffect } from 'react';
import HeaderV3 from '../../components/HeaderV3/headerV3.component';
import PartnerHeroSection from './partners-components/PartnersHeroSection/partnersherosection';
import PartnersSection from './partners-components/PartnerSection/partnerssection.component';
import OrbixContact from '../../components/ContactSection/contact.component';
import FooterSection from '../../components/FooterSection/footersection.component';
import { Fragment } from "react";


function Partners() {
  useLayoutEffect(() => {
    document.body.style.backgroundColor = '#131022';
    return () => { document.body.style.backgroundColor = ''; };
  }, []);
  return (
    <Fragment>
    {/* main */}
    <main className="page-wrapper dark-mode">
    {/* Header  */}
    <HeaderV3 />

    {/* Hero  */}
    <PartnerHeroSection/>

    {/* Partners Section  */}
    <PartnersSection/>

    {/* Contact -1 */}
    <OrbixContact/>

    <FooterSection />
    </main>

    </Fragment>
  )
}

export default Partners